import React from 'react';
import styled from 'styled-components';

interface SellerLocationProps {
  location: string;
}

export const SellerLocation = ({ location }: SellerLocationProps) => <Text>{location}</Text>;

const Text = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #575757;
  text-transform: capitalize;
`;
